import React from 'react'
import { ChatBreakoutSquare, CommandIcon, LikeIcon, LoadingIcon, MessageChatCircle, MessageHeartIcon, MessageSmileCircle, Zap } from '../../../icons'

const AccessCard = ({ icon, title, detail }) => {
    return (
        <div className="flex flex-col gap-[20px] w-full items-center">
            <div className="flex items-center justify-center p-[8px] rounded-full bg-[#A4D6B4] w-fit">
                <div className="flex items-center justify-center p-[8px]  rounded-full bg-[#1C9943]">
                    {icon}
                </div>
            </div>
            <div className="flex flex-col gap-[8px] items-center">
                <span className='text-[#101828] text-[20px] font-bold text-center'>
                    {title}
                </span>
                <p className='text-[16px] text-[#475467] text-center'>
                    {detail}
                </p>
            </div>
        </div>
    )
}

const AccessSection = () => {
    return (
        <div className='flex flex-col py-[96px] px-[7.7vw] gap-[64px]  items-center max-w-[1980px]'>
            <div className="flex flex-col gap-[20px] items-center max-w-[768px]">
                <div className="flex flex-col gap-[12px] items-center">
                    <span className='text-[#1C9943] font-[600] text-center'>
                        How to access
                    </span>
                    <h2 className='text-[#101828] sm:text-[36px] text-[32px] font-[600] text-center'>
                        Accessing Physiotherapy Services
                    </h2>
                </div>
                <span className='text-[#475467] sm:text-[20px] text-[16px] text-center'>
                    Your Path to Pain Relief and Mobility
                </span>
            </div>
            <div className="grid lg:grid-cols-3 gap-[32px] md:grid-cols-2 grid-cols-1">
                <AccessCard
                    icon={<MessageChatCircle iconColor={'#FFF'} />}
                    title={'Self-Referrals'}
                    detail={'If you’ve gradually developed an issue, sustained a sporting injury, had recent surgery or simply want support with pre-hab and general well-being, then PhysioMiles can provide home services to help formulate a diagnosis, give clinical advice and create a rehabilitation programme suitable for you. Simply send your query for a free telephone consultation'} />
                <AccessCard
                    icon={<Zap className={''} iconColor={'#FFF'} />}
                    title={'Medico-legal'}
                    detail={'Whether you’ve had a motor vehicle accident or work related injury, PhysioMiles can liaise with you’re insurance company and/or employers to provide physiotherapy assessments, written reports and treatment as needed in the comfort of your own home.'} />
                <AccessCard
                    icon={<ChatBreakoutSquare iconColor={'#FFF'} />}
                    title={'Private insurance companies'}
                    detail={'PhysioMiles is now recognised by a range of medical insurance companies, who will cover the costs of your physiotherapy treatment granted that you hold a valid policy.'} />
            </div>
        </div>
    )
}

export default AccessSection